import { Currency, IsoLocale } from '@izettle/constants';
import { createFormatHelpers } from '../../../schema/common/format';
export const locale = IsoLocale.esES;
export const currency = Currency.EUR;
export const { formatCurrencyRange, formatPercentRange } = createFormatHelpers(locale, currency);
